import { CommonModule } from "@angular/common";
import { NgModule } from '@angular/core';;
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgbRatingModule } from "@ng-bootstrap/ng-bootstrap";
import { CustomPipesModule } from "app/shared/custom-pipes/custom-pipes.module";
import { SliderModule } from "../slider/slider.module";
import { AllFiltersComponent } from "./all-filters.component";
import { NgxMaskModule } from 'ngx-mask';

@NgModule({

    declarations: [
        AllFiltersComponent,
    ],
    exports: [
        AllFiltersComponent,
    ],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        SliderModule,
        CustomPipesModule,
        NgbRatingModule,
        NgxMaskModule
    ]
})

export class AllFiltersModule {}